import { observer } from "mobx-react"

const ContractFeatures = observer(() => {


    const contractAddress = "0x81dcD01b9503563feEF165710e687680901Abd7A";


    const copyToClipboard = () => {
        navigator.clipboard
            .writeText(contractAddress)
            .then(() => {
                alert("Contract address copied to clipboard!");
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };
    return (<>
        <section className="" id="contractAdress">
            <div className="overlay">
                <div className="">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start bg-light ">
                        <div className="col-md-6 col-lg-6 col-md-6 sticky-top py-4 px-4 px-md-0 bg-white-gradient row-reverse">
                            <div className="d-flex justify-content-center">
                                <h1 className="heding-top">

                                    <span className="contract-address-container">
                                        <div className="contract-address-wrapper">
                                            <div className="contract-address-label">
                                                <strong>Contract Address:</strong>
                                            </div>
                                            <div className="contract-address-text" id="contractAddress">
                                                {contractAddress}
                                            </div>
                                            <button
                                                className="copy-button"
                                                onClick={copyToClipboard}
                                                aria-label="Copy Contract Address"
                                            >
                                                <span className="copy-icon">📋</span>
                                                <span className="copy-text">Copy</span>
                                            </button>



                                        </div>
                                    </span>

                                </h1>
                            </div>

                            <div className="main">
                                <h1 className="main-heading">
                                    <span className="main-heading-primary">Contract Features</span>
                                    <span className="main-heading-secondary">
                                        {" "}
                                        Here are some of the most common details we receive about
                                        Snowball bunny:
                                    </span>
                                </h1>


                            </div>

                            <img src="assets/img/front.png" className="header-img-coin4" />





                        </div>

                        <div className="col px-3 mt-3">
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingOne">
                                        <img src="assets/img/snowball7.jpg" className="img-fluid" />
                                    </h2>
                                    <div>
                                        <div className="accordion-body">
                                            <b>Leader of the Flushed Pets:</b> Snowball, once a
                                            domesticated pet, became bitter toward humans after being
                                            abandoned. He formed a gang of abandoned animals who live in
                                            the sewers and plot revenge against humans.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingOne">
                                        <img src="assets/img/snowball8.jpg" className="img-fluid" />
                                    </h2>
                                    <div>
                                        <div className="accordion-body">
                                            <b>Encounter with Max and Duke: </b>Snowball initially sees
                                            Max and Duke, the main characters, as allies when they claim
                                            to hate humans. He brings them into his group, but when he
                                            discovers they are lying, he becomes their adversary.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingOne">
                                        <img src="assets/img/snowball7.jpg" className="img-fluid" />
                                    </h2>
                                    <div>
                                        <div className="accordion-body">
                                            <b>Redemption Arc:</b> Through a series of wild adventures,
                                            including a battle with animal control, Snowball realizes
                                            the value of companionship and begins to let go of his
                                            grudge against humans.
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item mb-0">
                                    <h2 className="accordion-header" id="headingOne">
                                        <img src="assets/img/snowball9.jpg" className="img-fluid" />
                                    </h2>
                                    <div>
                                        <div className="accordion-body">
                                            <b> Happy Ending: </b> By the end of the movie, Snowball
                                            finds a loving new owner, a little girl, and embraces his
                                            life as a pet once again, showing a softer, more caring side
                                            of his personality.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>)
});

export default ContractFeatures;